<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { cn } from "@/shared/lib/utils"

// Презентаційний layout-блок (заголовок + опис). Mobile-first: текст ліворуч,
// колонка зверху-вниз.
const props = defineProps<{ class?: HTMLAttributes["class"] }>()
</script>

<template>
  <div
    data-slot="sheet-header"
    :class="cn('flex flex-col gap-1.5 text-left', props.class)"
  >
    <slot />
  </div>
</template>
